import React, { Component } from "react"
import { split, concat, flatMap } from "lodash"
import fetch from "cross-fetch"
import moment from "moment"
import queryString from "query-string"
import InfiniteScroll from "react-infinite-scroller"
import * as Icon from "react-feather"

import EventsFilter from "../event-filter"
import countries from "../../helpers/countries"
import EventItem from "../event-item"
import Loader from "../loader"
import EventsConfig from "../../helpers/eventsConfig"
import Button from "../button"
import storyblokLinkHandler from "../../helpers/storyblokLinkHandler"

const buildSearchQuery = (search) => {
  const searchWords = split(search, " ")
  return `${searchWords.join("* | ")}*`
}

class EventResults extends Component {
  page = 0
  size = 48

  state = {
    loading: true,
    events: [],
    search: "",
    offset: 0,
    total: 0,
    userCountryCode: [],
    userCountry: "",
    programs: [],
    types: [],
    showFilters: false,
  }

  async componentDidMount() {
    let paramsObj = {}

    if (typeof window !== "undefined" && window.location.search) {
      const query = queryString.parse(window.location.search)
      const { eventtype, program, country } = query
      let programCodes = []

      program &&
        program.split(",").map((program) => {
          const prog = program === "Masters" ? "One-Year Masters" : program
          return programCodes.push(prog)
        })

      paramsObj = {
        types: eventtype
          ? eventtype
            .split(",")
            .map((type) => (type === "One-to-One" ? "121" : type))
          : [],
        programs: program ? programCodes : [],
        userCountryCode: country
          ? this.countryNameToCode(country.split(","))
          : [],
        userCountry: countries[country] || [],
      }
    }

    this.search({ ...paramsObj })
  }

  componentDidUpdate() {
    const { loading } = this.state

    if (loading) {
      this.page = 0
      this.buildUrlParams()
      return this.search()
    }
  }

  buildUrlParams = () => {
    const { userCountryCode, programs, types } = this.state

    if (typeof window !== "undefined" && window.history.pushState) {
      const basePath = `${window.location.origin}${window.location.pathname}`

      const paramsArr = []

      types.length > 0 &&
        paramsArr.push(
          `eventtype=${this.formatParams(
            types.map((type) => (type === "121" ? "One-to-One" : type))
          )}`
        )

      programs.length > 0 &&
        paramsArr.push(`program=${this.formatParams(programs)}`)

      userCountryCode.length > 0 &&
        paramsArr.push(
          `country=${this.formatParams(
            this.countryCodeToName(userCountryCode)
          )}`
        )

      const params = paramsArr.join("&")

      const newUrl = params ? basePath + "?" + params : basePath

      window.history.pushState({ path: newUrl }, "", newUrl)
    }
  }

  formatParams = (arr) => arr.join(",").replace(/\s/g, "%20")

  search = (paramsObj) => {
    this.page += 1
    const {
      search,
      offset,
      events,
      userCountryCode,
      programs,
      types,
    } = this.state

    const filters =
      typeof paramsObj === "number" || !paramsObj
        ? this.filterHandler(
          userCountryCode,
          this.programValues(programs),
          types
        )
        : this.filterHandler(
          paramsObj.userCountryCode,
          this.programValues(paramsObj.programs),
          paramsObj.types
        )

    return fetch(`${process.env.GATSBY_HULTEDUDATA_API}/events/search`, {
      method: "POST",
      body: JSON.stringify({
        from: offset,
        size: this.size,
        search: buildSearchQuery(search),
        filters,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then((result) => {
        let stateObj = {
          events: this.imgHandler(
            concat(
              events,
              flatMap(result.hits.hits, (f) => f._source)
            )
          ),
          loading: false,
          total: result.hits.total,
          offset: this.page * this.size,
        }


        return this.setState(
          paramsObj ? Object.assign({}, stateObj, paramsObj) : stateObj
        )
      })
      .catch((err) => {
        console.error(err)
      })
  }

  programValues = (programs) => {
    const { programList } = this.props.eventsConfig
    let vals = []

    programList &&
      programList.length > 0 &&
      programList.map((e) => {
        if (programs.includes(e.name)) {
          vals.push(...e.value.split(";"))
        }
      })
    return vals
  }

  filterHandler = (userCountryCode, programs, types) => {
    const countryFilter = { field: "Country", options: userCountryCode }
    const programFilter = { field: "Programs", options: programs }
    const typeFilter = { field: "Type", options: types }

    let filters = []

    userCountryCode.length > 0 && filters.push(countryFilter)
    programs.length > 0 && filters.push(programFilter)
    types.length > 0 && filters.push(typeFilter)

    return filters
  }

  randomElement = (arr) => {
    return arr[Math.floor(Math.random() * arr.length)]
  }

  imgHandler = (events) => {
    const { specifyEventImage, eventTypeImages } = this.props.eventsConfig

    return events.map((event) => {
      const { Type, Id } = event
      const eventType = Type === "121" ? "One-to-One" : Type
      const eventId = Id.split("-")[0]
      const { img } = eventTypeImages.filter(
        (imgType) => eventType.toLowerCase() === imgType.type.toLowerCase()
      )[0]
      const specImg =
        specifyEventImage.filter((img) => img.eventId === eventId) || []

      switch (true) {
        case specImg.length > 0:
          event.image = this.randomElement(specImg).image
          return event
        default:
          event.image = this.randomElement(img).image
          return event
      }
    })
  }

  countryCodeToName = (codeArr) => {
    return codeArr.map((code) => countries[code])
  }

  countryNameToCode = (countryArr) => {
    return countryArr.map((name) =>
      Object.keys(countries).find(
        (key) => countries[key].toLowerCase() === name.toLowerCase()
      )
    )
  }

  programHandler = (event) => {
    const { name } = event.target
    const { programs } = this.state

    let programsArr = programs

    switch (true) {
      case !name:
        programsArr = []
        break
      case programs.includes(name):
        programsArr = programsArr.filter((prog) => prog !== name)
        break
      default:
        programsArr.push(name)
    }

    this.setState({
      programs: programsArr,
      events: [],
      offset: 0,
      total: 0,
      loading: true,
    })
  }

  typesHandler = (event) => {
    const { value } = event.target
    const { types } = this.state

    let typeArr = types

    let val = value === "One-to-One" ? "121" : value

    switch (true) {
      case !val:
        typeArr = []
        break
      case types.includes(val):
        typeArr = typeArr.filter((type) => type !== val)
        break
      default:
        typeArr.push(val)
    }

    this.setState({
      types: typeArr,
      events: [],
      offset: 0,
      total: 0,
      loading: true,
    })
  }

  locationHandler = (event) => {
    const { value } = event.target
    const { userCountryCode } = this.state

    let countryArr = userCountryCode

    switch (true) {
      case !value:
        countryArr = []
        break
      case userCountryCode.includes(value):
        countryArr = countryArr.filter((prog) => prog !== value)
        break
      default:
        countryArr.push(value)
    }

    this.setState({
      userCountryCode: countryArr,
      events: [],
      offset: 0,
      total: 0,
      loading: true,
    })
  }

  toggleFilters = () => {
    const { showFilters } = this.state

    this.setState({
      showFilters: !showFilters,
    })
    window.scrollTo(0, 0)
  }

  programTagHandler = (programArr) => {
    return programArr.map((code) => {
      const programArr = this.props.eventsConfig.programList.filter(
        (listProg) => code === listProg.value
      )
      return programArr.length === 1 ? programArr[0].name : ""
    })
  }

  render() {
    const {
      events,
      userCountryCode,
      programs,
      types,
      loading,
      offset,
      total,
      showFilters,
    } = this.state

    const {
      eventTypeList,
      fallbackEvent,
      programList,
    } = this.props.eventsConfig

    return (
      <>
        <React.Fragment>
          <Button
            className="btn--wide btn--cta event-discovery__filter-btn"
            text="Filter events"
            iconName="Filter"
            onClick={this.toggleFilters}
          />
          <div
            className={`event-discovery__filters ${showFilters ? "event-discovery__filters--visible" : ""
              }`}
          >
            <div className="event-discovery__filters-container">
              <header className="event-discovery__filters-header">
                <Icon.X
                  className="event-discovery__filters-icon icon icon--sm"
                  onClick={this.toggleFilters}
                />
                <p className="event-discovery__filters-title">Filter events</p>
              </header>
              <EventsFilter
                onProgramChange={this.programHandler}
                onTypeChange={this.typesHandler}
                onCountryChange={this.locationHandler}
                location={userCountryCode}
                defaultLocation={userCountryCode[0]}
                programList={programList}
                typesList={eventTypeList}
                showBtn={false}
                selectedProgram={
                  programs.length > 0 &&
                  `${programs[0]}${programs.length > 1 ? "..." : ""}`
                }
                programsArr={programs}
                countriesList={countries}
                selectedLocation={
                  userCountryCode.length > 1
                    ? `${countries[userCountryCode[0]]}...`
                    : countries[userCountryCode[0]]
                }
                countriesArr={userCountryCode}
                selectedType={
                  types.length > 0 &&
                  `${types[0] === "121" ? "One-to-One" : types[0]}
                    ${types.length > 1 ? "..." : ""}`
                }
                typesArr={types.map((type) =>
                  type === "121" ? "One-to-One" : type
                )}
                onClick={this.toggleFilters}
              />
            </div>
          </div>
        </React.Fragment>
        {!loading ? (
          <div className="event-group">
            <header className="event-group__header">
              <p className="event-group__name">
                {total !== 0 ? total : 1} event{total > 1 && "s"} found
              </p>
            </header>
            <InfiniteScroll
              pageStart={0}
              loadMore={this.search}
              hasMore={loading || offset < total}
              loader={<Loader key={0} />}
              className="search-results"
              threshold={500}
            >
              <div className="event-group__list">
                {events.length > 0 ? (
                  events.map((event, index) => (
                    <>
                      <div className="event-group__item" key={index} data-event-id={event.Id}>
                        <EventItem
                          date={moment
                            .utc(event.StartDatetime)
                            .format("llll")
                            .split(" ")
                            .slice(0, -2)
                            .join(" ")}
                          url={event.Link}
                          name={event.Title}
                          location={
                            event.Region === "Global"
                              ? "Available Worldwide"
                              : countries[event.Country]
                          }
                          image={event.image}
                          tags={this.programTagHandler(event.Programs)}
                        />
                      </div>
                    </>
                  ))
                ) : (
                  <div className="event-group__item">
                    <EventItem
                      url={storyblokLinkHandler(fallbackEvent[0].url)}
                      name={fallbackEvent[0].title}
                      image={fallbackEvent[0].image}
                      description={fallbackEvent[0].description}
                    />
                  </div>
                )}
              </div>
            </InfiniteScroll>
          </div>
        ) : (
          <Loader />
        )}
      </>
    )
  }
}

export default EventsConfig(EventResults)
